<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:header>
      <div class="d-flex justify-space-between w-100">
        <v-card-title class="screen-title">
          インターネットセキュリティアプライアンスポリシー設定
        </v-card-title>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="closeModal"
        >
          ×
        </button>
      </div>
    </template>
    <template v-if="isLoaded" v-slot:body>
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container fluid class="pa-0">
            <v-row justify="space-between" align="center" class="my-2">
              <v-radio-group
                inline
                density="comfortable"
                class="ml-2"
                v-model="direction"
                hide-details
              >
                <v-radio
                  value="accessPointToInternet"
                  label="アクセス拠点 → インターネット"
                />
                <v-radio
                  value="internetToAccessPoint"
                  label="インターネット → アクセス拠点"
                />
              </v-radio-group>
              <div class="d-flex mr-2 ga-1">
                <v-btn
                  color="primary"
                  @click="downloadConfig"
                  v-permission.config
                  >設定ダウンロード
                </v-btn>
                <v-btn color="primary" @click="uploadConfig" v-permission.config
                  >設定アップロード
                </v-btn>
              </div>
            </v-row>
            <template v-if="direction === 'accessPointToInternet'">
              <v-tabs hide-slider grow v-model="tabValue">
                <v-tab text="NAT(IP Masquerade)" value="NAT" />
                <v-tab text="インターネットFW" value="IFW" />
              </v-tabs>
              <v-tabs-window
                v-model="tabValue"
                class="border-s-sm border-b-sm border-e-sm"
              >
                <v-tabs-window-item value="NAT">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyIPMasqueradeType4!.policyList.length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyAccessToInternetNAT"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="a2iNatTable.fields"
                    :items="policy.policyIPMasqueradeType4!.policyList"
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddressList)="{ value }">
                      <policy-src-address
                        :src-address="{ srcAddressList: value }"
                      />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddressList)="{ value }">
                      <policy-dst-address
                        :dst-address="{ dstAddressList: value }"
                      />
                    </template>

                    <!-- IP Pool -->
                    <template #cell(ipPoolList)="{ value }">
                      <policy-ip-pool :ip-pool-list="value" />
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
                <v-tabs-window-item value="IFW">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyIfwType4!.accessPointToInternetPolicyList
                          .length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyAccessToInternetIFW"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="a2iIfwTable.fields"
                    :items="
                      policy.policyIfwType4!.accessPointToInternetPolicyList
                    "
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddress)="{ value }">
                      <policy-src-address :src-address="value" />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddress)="{ value }">
                      <policy-dst-address :dst-address="value" />
                    </template>

                    <!-- サービス -->
                    <template #cell(service)="{ item }">
                      <policy-service
                        :service-option="item.serviceOption"
                        :default-service-list="item.defaultServiceList"
                        :custom-service-list="item.customServiceList"
                      />
                    </template>

                    <!-- プロファイル -->
                    <template #cell(profile)="{ value }">
                      <policy-profile :profile="value" />
                    </template>

                    <!-- アクション -->
                    <template #cell(actionType)="{ value }">
                      {{ $filter.enumTo(value, "allow_deny") }}
                    </template>

                    <!-- ログ出力 -->
                    <template #cell(isLogOutput)="{ value }">
                      {{ $filter.enumTo(value, "on_off") }}
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
              </v-tabs-window>
            </template>
            <template v-if="direction === 'internetToAccessPoint'">
              <v-tabs hide-slider grow v-model="tabValue">
                <v-tab text="NAT(IP Forwarding)" value="NAT" />
                <v-tab text="インターネットFW" value="IFW" />
              </v-tabs>
              <v-tabs-window
                v-model="tabValue"
                class="border-s-sm border-b-sm border-e-sm"
              >
                <v-tabs-window-item value="NAT">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyNatType4!.policyList.length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyInternetToAccessNAT"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="i2aNatTable.fields"
                    :items="policy.policyNatType4!.policyList"
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="() => undefined"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddressList)="{ value }">
                      <policy-src-address
                        :src-address="{ srcAddressList: value }"
                      />
                    </template>

                    <!-- IPマッピング -->
                    <template #cell(ipMapping)="{ value }">
                      <template v-if="value"
                        >{{ value.ipMappingName }}
                      </template>
                      <template v-else>-</template>
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
                <v-tabs-window-item value="IFW">
                  <v-row
                    no-gutters
                    justify="space-between"
                    class="my-2"
                    align="center"
                  >
                    <span
                      >{{
                        policy.policyIfwType4!.internetToAccessPointPolicyList
                          .length
                      }}件を表示</span
                    >
                    <v-btn
                      color="primary"
                      @click="editPolicyInternetToAccessIFW"
                      v-permission.config
                    >
                      ポリシー編集
                    </v-btn>
                  </v-row>
                  <app-table
                    density="compact"
                    :fields="i2aIfwTable.fields"
                    :items="
                      policy.policyIfwType4!.internetToAccessPointPolicyList
                    "
                    :per-page="-1"
                    primary-key="policyId"
                    :td-class="tdClass"
                    :tr-class="policyRowClass"
                  >
                    <!-- 送信元 -->
                    <template #cell(srcAddress)="{ value }">
                      <policy-src-address :src-address="value" />
                    </template>

                    <!-- 宛先 -->
                    <template #cell(dstAddress)="{ value }">
                      <policy-dst-address :dst-address="value" />
                    </template>

                    <!-- サービス -->
                    <template #cell(service)="{ item }">
                      <policy-service
                        :service-option="item.serviceOption"
                        :default-service-list="item.defaultServiceList"
                        :custom-service-list="item.customServiceList"
                      />
                    </template>

                    <!-- プロファイル -->
                    <template #cell(profile)="{ value }">
                      <policy-profile :profile="value" />
                    </template>

                    <!-- アクション -->
                    <template #cell(actionType)="{ value }">
                      {{ $filter.enumTo(value, "allow_deny") }}
                    </template>

                    <!-- ログ出力 -->
                    <template #cell(isLogOutput)="{ value }">
                      {{ $filter.enumTo(value, "on_off") }}
                    </template>

                    <!-- 有効/有無 -->
                    <template #cell(isPolicyStatus)="{ value }">
                      {{ $filter.enumTo(value, "enable") }}
                    </template>

                    <!-- 備考 -->
                    <template #cell(description)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
              </v-tabs-window>
            </template>
          </v-container>
        </div>
        <v-alert v-if="!!uploadAlert" class="my-4" :text="uploadAlert" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              variant="flat"
              color="primary"
              @click="putPolicy"
              v-permission.config
            >
              ポリシー設定反映
            </v-btn>
            <v-btn variant="outlined" color="primary" @click="closeModal"
              >キャンセル
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import InternetType4PolicyRuleIpMasqViewRD from "@/modals/applianceContractSetting/type4/policy/ipMasquerade/InternetType4PolicyRuleIpMasqViewRD.vue";
import InternetType4PolicyRuleDestNatViewRD from "@/modals/applianceContractSetting/type4/policy/ipForwarding/InternetType4PolicyRuleDestNatViewRD.vue";
import type { Type4Service } from "@/apis/ContractChangeType4Api";
import type { GetPolicy, GetPolicyType4 } from "@/apis/NwPolicyApi";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import PolicyDstAddress from "@/components/policy/PolicyDstAddress.vue";
import PolicyIpPool from "@/components/policy/PolicyIpPool.vue";
import PolicyProfile from "@/components/policy/PolicyProfile.vue";
import PolicyService from "@/components/policy/PolicyService.vue";
import { UploadError } from "@/services/ConfigDownloadService";
import type { AppTableHeader } from "@/components/AppTable.vue";
import InternetType4PolicyRuleIfwViewRD from "@/modals/applianceContractSetting/type4/policy/ifw/InternetType4PolicyRuleIfwViewRD.vue";
import { VueFinalModal } from "vue-final-modal";
import {
  get2putPolicy,
  setNewPolicyObjectIdToNull,
} from "@/modals/applianceContractSetting/type4/policy/InternetType4PolicyUtmList.vue";
import InternetType4PolicyIfwConfirm from "@/modals/applianceContractSetting/type4/policy/InternetType4PolicyIfwConfirm.vue";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

export default defineComponent({
  name: "InternetType4PolicyIfwList",
  components: {
    PolicyService,
    PolicyProfile,
    PolicyIpPool,
    PolicyDstAddress,
    PolicySrcAddress,
  },
  props: {
    /** Type4Id. 主キー */
    type4Id: {
      type: String as PropType<string>,
      required: true,
    },
    /** サービスメニュー(インターネットType4) */
    type4Service: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "IFW" as "NAT" | "IFW",
      direction: "accessPointToInternet",
      policy: {} as GetPolicyType4,
      originalPolicy: {} as GetPolicyType4,
      i2aNatTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddressList", title: "送信元アドレス", width: "150px" },
          { key: "ipMapping", title: "IPマッピング", width: "200px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      i2aIfwTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddress", title: "送信元アドレス", width: "150px" },
          { key: "dstAddress", title: "宛先アドレス", width: "150px" },
          { key: "service", title: "サービス", width: "15%" },
          { key: "profile", title: "プロファイル", width: "20%" },
          { key: "actionType", title: "アクション", width: "80px" },
          { key: "isLogOutput", title: "ログ出力", width: "70px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      a2iNatTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddressList", title: "送信元アドレス", width: "150px" },
          { key: "dstAddressList", title: "宛先アドレス", width: "150px" },
          { key: "ipPoolList", title: "IP Pool", width: "150px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      a2iIfwTable: {
        fields: [
          { key: "policyId", title: "ID", width: "80px" },
          { key: "srcAddress", title: "送信元アドレス", width: "150px" },
          { key: "dstAddress", title: "宛先アドレス", width: "150px" },
          { key: "service", title: "サービス", width: "15%" },
          { key: "profile", title: "プロファイル", width: "20%" },
          { key: "actionType", title: "アクション", width: "80px" },
          { key: "isLogOutput", title: "ログ出力", width: "70px" },
          { key: "isPolicyStatus", title: "有効/無効", width: "70px" },
          { key: "description", title: "備考" },
        ],
      },
      uploadAlert: null as string | null,
      isLoaded: false,
    };
  },
  async mounted() {
    this.policy = await this.$api.nwPolicy.getType4Policies(
      this.type4Id,
      "IFW_IPMASQUERADE_NAT"
    );
    this.originalPolicy = cloneDeep(this.policy);
    this.isLoaded = true;
  },
  computed: {
    /** 変更があるかどうかを判定（policyKeyIdは比較から除外） */
    hasChanges(): boolean {
      const normalize = (p: GetPolicyType4) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { policyKeyId, ...rest } = p ?? ({} as GetPolicyType4);
        return rest;
      };
      return !isEqual(normalize(this.policy), normalize(this.originalPolicy));
    },
  },
  methods: {
    /** モーダルを閉じる処理（変更がある場合は確認ダイアログを表示） */
    async closeModal(): Promise<void> {
      if (!this.hasChanges) {
        (
          this.$refs.modal as typeof VueFinalModal & { cancel: () => void }
        ).cancel();
        return;
      }
      try {
        await this.$confirm("変更を破棄してキャンセルします、よろしいですか？");
        (
          this.$refs.modal as typeof VueFinalModal & { cancel: () => void }
        ).cancel();
      } catch {
        return;
      }
    },
    tdClass(field: AppTableHeader<unknown>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
    /** 設定反映 */
    async putPolicy() {
      this.uploadAlert = null;
      // ポリシー画面からオブジェクトを追加するとkeyIdを更新する必要があるため以下で再取得
      this.isLoaded = false;
      this.policy.policyKeyId = (
        await this.$api.nwPolicy.getType4Policies(
          this.type4Id,
          "IFW_IPMASQUERADE_NAT"
        )
      ).policyKeyId;
      this.isLoaded = true;
      await this.$modal.show(InternetType4PolicyIfwConfirm, {
        type4Policy: this.policy,
        type4Service: this.type4Service,
      });
      await this.$api.nwPolicy.putType4Policies(
        this.type4Id,
        get2putPolicy(this.policy),
        "IFW_IPMASQUERADE_NAT"
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 設定ダウンロード */
    downloadConfig() {
      this.$service.configDownload.downloadInternetType4Policy(
        this.type4Id,
        "IFW",
        this.policy
      );
    },

    /** 設定アップロード */
    async uploadConfig() {
      try {
        const uploadPolicy =
          await this.$service.configDownload.uploadInternetType4Policy(
            this.type4Id,
            "IFW",
            this.policy
          );
        this.uploadAlert = null;
        await this.$confirm(
          "ポリシー設定を上書きします。設定反映していない設定は破棄されます。よろしいですか？"
        );
        setNewPolicyObjectIdToNull(uploadPolicy, this.originalPolicy);
        this.policy = uploadPolicy;
      } catch (e) {
        this.uploadAlert = (e as UploadError).message;
      }
    },

    /** インターネット→アクセス拠点 NATのポリシーを編集 */
    async editPolicyInternetToAccessNAT() {
      this.uploadAlert = null;
      this.policy.policyNatType4!.policyList = await this.$modal.show(
        InternetType4PolicyRuleDestNatViewRD,
        {
          type4Id: this.type4Id,
          policyList: this.policy.policyNatType4!.policyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        }
      );
    },

    /** インターネット→アクセス拠点 FWのポリシーを編集 */
    async editPolicyInternetToAccessIFW() {
      this.uploadAlert = null;
      this.policy.policyIfwType4!.internetToAccessPointPolicyList =
        await this.$modal.show(InternetType4PolicyRuleIfwViewRD, {
          type4Id: this.type4Id,
          from: "INTERNET",
          policyList:
            this.policy.policyIfwType4!.internetToAccessPointPolicyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        });
    },

    /** アクセス拠点→インターネット NATのポリシーを編集 */
    async editPolicyAccessToInternetNAT() {
      this.uploadAlert = null;
      this.policy.policyIPMasqueradeType4!.policyList = await this.$modal.show(
        InternetType4PolicyRuleIpMasqViewRD,
        {
          type4Id: this.type4Id,
          policyList: this.policy.policyIPMasqueradeType4!.policyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        }
      );
    },

    /** アクセス拠点→インターネット FWのポリシーを編集 */
    async editPolicyAccessToInternetIFW() {
      this.uploadAlert = null;
      this.policy.policyIfwType4!.accessPointToInternetPolicyList =
        await this.$modal.show(InternetType4PolicyRuleIfwViewRD, {
          type4Id: this.type4Id,
          from: "ACCESS_POINT",
          policyList:
            this.policy.policyIfwType4!.accessPointToInternetPolicyList,
          type4Policy: this.policy,
          type4Service: this.type4Service,
        });
    },

    /**
     * ポリシーテーブルのtrクラス.
     * 編集不可デフォルトポリシーの場合は特定のクラスを返す
     */
    policyRowClass(
      item: Pick<GetPolicy, "policyCategoryInfo">
    ): string[] | undefined {
      return item.policyCategoryInfo === "UNEDITABLE_DEFAULT_POLICY"
        ? ["gray-out"]
        : undefined;
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(th) {
  font-size: 90%;
}
</style>
